export default "__VITE_ASSET__DTndjziA__"